import { render, staticRenderFns } from "./LearnPageSearchItem.vue?vue&type=template&id=8ddc7a52&scoped=true"
import script from "./LearnPageSearchItem.vue?vue&type=script&lang=js"
export * from "./LearnPageSearchItem.vue?vue&type=script&lang=js"
import style0 from "./LearnPageSearchItem.vue?vue&type=style&index=0&id=8ddc7a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ddc7a52",
  null
  
)

export default component.exports